import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectPersonalAccidentSCTIStep, makeSelectPersonalAccidentSCTIStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormClaimRelatedToPersonalAccident,
  resetFormClaimRelatedToLossOfLife,
  resetFormClaimRelatedInjuryLeaveYouPermanently,
  resetFormClaimRelatedInjuryResult,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { stepMedicalAndEvacuationLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { AdditionalList } from './components/Additional';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectPolicyTypeCode } from '../../App/selectors';

export class PersonalAccidentSCTIStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onPrescriptionMedicinesNotInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesNotInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionMedicinesForInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesForInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  // Personal Accident
  onClaimRelatedToPersonalAccidentChange = (data) => {
    this.props.onFormDataChange('form.infoClaimRelatedToPersonalAccidentItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onClaimRelatedToLossOfLifeChange = (data) => {
    this.props.onFormDataChange('form.infoClaimRelatedToLossOfLifeItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onClaimRelatedInjuryLeaveYouPermanentlyChange = (data) => {
    this.props.onFormDataChange('form.infoDidTheInjuryLeaveYouPermanentlyDisabledItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onClaimRelatedInjuryResultChange = (data) => {
    this.props.onFormDataChange('form.infoYourInabilityToReturnToWorkItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      if (name === 'Medical Expenses') {
        this.props.onResetFormMedicalExpenses();
      }
      if (name === 'Dental Expenses') {
        this.props.onResetFormDentalExpenses();
      }
      if (name === 'Funeral Expenses') {
        this.props.onResetFormFunarelExpenses();
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  // Personal Accident
  renderClaimRelatedToPersonalAccidentItems() {
    const { infoClaimRelatedToPersonalAccidentItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoClaimRelatedToPersonalAccidentItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onClaimRelatedToPersonalAccidentChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderClaimRelatedToLossOfLifeItems() {
    const { infoClaimRelatedToLossOfLifeItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoClaimRelatedToLossOfLifeItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onClaimRelatedToLossOfLifeChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderClaimRelatedInjuryLeaveYouPermanentlyItems() {
    const { infoDidTheInjuryLeaveYouPermanentlyDisabledItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoDidTheInjuryLeaveYouPermanentlyDisabledItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onClaimRelatedInjuryLeaveYouPermanentlyChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderClaimRelatedInjuryResultItems() {
    const { infoYourInabilityToReturnToWorkItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoYourInabilityToReturnToWorkItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onClaimRelatedInjuryResultChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderPersonalAccident() {
    const {
      isThisClaimRelatedToPersonalAccident,
      isThisClaimRelatedToLossOfLifeCausedByAnInjury,
      didTheInjuryLeaveYouPermanentlyDisabled,
      didTheInjuryResultInYourInabilityToReturnToWork,
      dateYouWereOriginallyDueBackAtWork,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, policyTypeCode } = this.props;
    const listLossOfIncomeBenefitCode = ['DOM-AU', 'VISIT-NZ', 'INT-STUDENT'];
    const hideDidTheInjuryResultInYourInabilityToReturnToWork = listLossOfIncomeBenefitCode.includes(policyTypeCode);
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.isThisClaimRelatedToPersonalAccident} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={isThisClaimRelatedToPersonalAccident === 'true'}
                  onChange={this.handleChange('form.isThisClaimRelatedToPersonalAccident')}
                  onClick={this.props.onResetFormClaimRelatedToPersonalAccident}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={isThisClaimRelatedToPersonalAccident === 'false'}
                  onChange={this.handleChange('form.isThisClaimRelatedToPersonalAccident')}
                  onClick={this.props.onResetFormClaimRelatedToPersonalAccident}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {isThisClaimRelatedToPersonalAccident === 'true' &&
          (this.renderClaimRelatedToPersonalAccidentItems())
        }
        {(isThisClaimRelatedToPersonalAccident === 'true') &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.isThisClaimRelatedToLossOfLifeCausedByAnInjury} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={isThisClaimRelatedToLossOfLifeCausedByAnInjury === 'true'}
                    onChange={this.handleChange('form.isThisClaimRelatedToLossOfLifeCausedByAnInjury')}
                    onClick={this.props.onResetFormClaimRelatedToLossOfLife}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={isThisClaimRelatedToLossOfLifeCausedByAnInjury === 'false'}
                    onChange={this.handleChange('form.isThisClaimRelatedToLossOfLifeCausedByAnInjury')}
                    onClick={this.props.onResetFormClaimRelatedToLossOfLife}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {isThisClaimRelatedToLossOfLifeCausedByAnInjury === 'true' &&
          (this.renderClaimRelatedToLossOfLifeItems())
        }
        {(isThisClaimRelatedToLossOfLifeCausedByAnInjury === 'false') &&
          <div className={'ml-3 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didTheInjuryLeaveYouPermanentlyDisabled} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didTheInjuryLeaveYouPermanentlyDisabled === 'true'}
                    onChange={this.handleChange('form.didTheInjuryLeaveYouPermanentlyDisabled')}
                    onClick={this.props.onResetFormClaimRelatedInjuryLeaveYouPermanently}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didTheInjuryLeaveYouPermanentlyDisabled === 'false'}
                    onChange={this.handleChange('form.didTheInjuryLeaveYouPermanentlyDisabled')}
                    onClick={this.props.onResetFormClaimRelatedInjuryLeaveYouPermanently}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {didTheInjuryLeaveYouPermanentlyDisabled === 'true' &&
          (this.renderClaimRelatedInjuryLeaveYouPermanentlyItems())
        }
        {(didTheInjuryLeaveYouPermanentlyDisabled !== '' && !hideDidTheInjuryResultInYourInabilityToReturnToWork) &&
          <div className={'ml-4 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didTheInjuryResultInYourInabilityToReturnToWork} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didTheInjuryResultInYourInabilityToReturnToWork === 'true'}
                    onChange={this.handleChange('form.didTheInjuryResultInYourInabilityToReturnToWork')}
                    onClick={this.props.onResetFormClaimRelatedInjuryResult}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didTheInjuryResultInYourInabilityToReturnToWork === 'false'}
                    onChange={this.handleChange('form.didTheInjuryResultInYourInabilityToReturnToWork')}
                    onClick={this.props.onResetFormClaimRelatedInjuryResult}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {didTheInjuryResultInYourInabilityToReturnToWork === 'true' &&
          <div className={'row'}>
            <div className={'col-sm-1 form-group'}>
            </div>
            <div className={'col-sm-5 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.dateYouWereOriginallyDueBackAtWork} />
              </PageSectionHeader>
            </div>
            <div className={'col-sm-5 form-group'}>
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="dateYouWereOriginallyDueBackAtWork"
                type="text"
                onDayChange={this.handleDayChange('form.dateYouWereOriginallyDueBackAtWork')}
                value={dateYouWereOriginallyDueBackAtWork}
              />
            </div>
            <div className={'col-sm-1 form-group'}>
            </div>
          </div>
        }
        {didTheInjuryResultInYourInabilityToReturnToWork === 'true' &&
          (this.renderClaimRelatedInjuryResultItems())
        }
      </div>
    );
  }

  renderDentalExpenses() {
    return (
      <div>
        {this.renderDentalExpensesItems()}
      </div>
    );
  }

  renderFuneralExpenses() {
    return (
      <div>
        {this.renderFuneralExpensesItems()}
      </div>
    );
  }

  render() {
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div>
          {this.renderPersonalAccident()}
        </div>
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

PersonalAccidentSCTIStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormData: PropTypes.func,
  onResetFormMedicalExpenses: PropTypes.func,
  onResetFormDentalExpenses: PropTypes.func,
  onResetFormFunarelExpenses: PropTypes.func,
  onResetFormClaimRelatedToPersonalAccident: PropTypes.func,
  onResetFormClaimRelatedToLossOfLife: PropTypes.func,
  onResetFormClaimRelatedInjuryLeaveYouPermanently: PropTypes.func,
  onResetFormClaimRelatedInjuryResult: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  policyTypeCode: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectPersonalAccidentSCTIStep(),
  errors: makeSelectPersonalAccidentSCTIStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  policyTypeCode: makeSelectPolicyTypeCode(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormData: () => dispatch(resetFormData()),
  onResetFormClaimRelatedToPersonalAccident: () => dispatch(resetFormClaimRelatedToPersonalAccident()),
  onResetFormClaimRelatedToLossOfLife: () => dispatch(resetFormClaimRelatedToLossOfLife()),
  onResetFormClaimRelatedInjuryLeaveYouPermanently: () => dispatch(resetFormClaimRelatedInjuryLeaveYouPermanently()),
  onResetFormClaimRelatedInjuryResult: () => dispatch(resetFormClaimRelatedInjuryResult()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'personalAccidentSCTIStep', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(PersonalAccidentSCTIStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.PersonalAccident/index.js